module.exports = __webpack_public_path__ + "img/c83e13b.jpg";